const ACRONYM_DENYLIST = new Set(['AVS', 'CVC', 'USD', 'SDF', 'TCB', 'PDF', 'IP']);

const SINGLE_WORD_ENUMS = new Set([
  'ACCEPTED',
  'DUPLICATE',
  'EXPIRED',
  'FRAUDULENT',
  'GENERAL',
  'LOST',
  'OPEN',
  'OTHER',
  'RECEIVED',
  'RESOLVED',
  'SERVICES',
  'UNRECOGNIZED',
  'WITHDRAWN',
  'WON',
]);

const ENUM_TOKEN_PATTERN = /\*{0,3}\b([A-Z][A-Z0-9]*(?:_[A-Z0-9]+)*)\b\*{0,3}/g;

const isEnumToken = (token: string): boolean => {
  if (!/^[A-Z][A-Z0-9]*(?:_[A-Z0-9]+)*$/.test(token)) {
    return false;
  }

  if (ACRONYM_DENYLIST.has(token)) {
    return false;
  }

  if (token.includes('_')) {
    return true;
  }

  return SINGLE_WORD_ENUMS.has(token);
};

/**
 * Wraps dispute/API enum tokens (e.g. FULL_REFUND, OPEN) in bold markdown
 * for legal document rendering. Skips inline and fenced code blocks.
 */
export const emphasizeDocumentEnumTokens = (markdown: string): string => {
  const segments = markdown.split(/(```[\s\S]*?```|`[^`]+`)/g);

  return segments
    .map((segment, index) => {
      if (index % 2 === 1) {
        return segment;
      }

      return segment.replace(ENUM_TOKEN_PATTERN, (match, token: string) => {
        if (!isEnumToken(token)) {
          return match;
        }

        return `**${token}**`;
      });
    })
    .join('');
};
